import type { ComponentStyle } from "@yamada-ui/core"

export const Image: ComponentStyle<"Image"> = {}
